import React, { useState, useContext } from "react";
import { Breadcrumb, Layout, Menu, theme, Image, Space, Flex } from "antd";
import SideFilter from "./components/sideFilter";
import DataTable from "./components/dataTable";
import FastEnters from "../../../components/fastEnters";
import { useLocation } from "react-router";
import { UserContext } from "../components/privateroute";
const storageKey = "sprawyShowAllActivity";
const SIMILAR_BACKUP_KEY = "sprawySimilarBackup";
const SIMILAR_ACTIVE_KEY = "sprawySimilarActive";
const SIMILAR_PREFIX = "sprawySimilar";

const Sprawy = () => {
	const [departs, setDeparts] = useState([]);
	const [showFilters, setShowFilters] = useState(false);
	const globalUser = useContext(UserContext);
	const isAdmin = Boolean(globalUser?.isadmin);
	const [tableKey, setTableKey] = useState(0);
	const [showAllActivity, setShowAllActivity] = useState(() => {
		try {
			const saved = localStorage.getItem(storageKey);
			return saved === "1";
		} catch {
			return false;
		}
	});
	const location = useLocation();
	const params = new URLSearchParams(location.search || "");
	const similar = params.get("similar") === "1";
	const activityModeParam = params.get("activityMode");
	const activityMode =
		similar &&
		(activityModeParam === "active" ||
			activityModeParam === "inactive" ||
			activityModeParam === "all")
			? activityModeParam
			: undefined;
	const resolvedActivityMode = showAllActivity
		? "all"
		: activityMode || "active";
	const resolvedStoragePrefix = similar ? SIMILAR_PREFIX : "sprawy";

	React.useEffect(() => {
		if (similar) return;
		try {
			const active = localStorage.getItem(SIMILAR_ACTIVE_KEY);
			const raw = localStorage.getItem(SIMILAR_BACKUP_KEY);
			if (!active || !raw) return;
			const backup = JSON.parse(raw);
			if (backup?.tableState != null) {
				localStorage.setItem("sprawyTableState", backup.tableState);
			} else {
				localStorage.removeItem("sprawyTableState");
			}
			if (backup?.advancedSearch != null) {
				localStorage.setItem(
					"sprawyAdvancedSearch",
					backup.advancedSearch,
				);
			} else {
				localStorage.removeItem("sprawyAdvancedSearch");
			}
			if (backup?.advancedSearchGlobal != null) {
				localStorage.setItem(
					"advancedSearch",
					backup.advancedSearchGlobal,
				);
			} else {
				localStorage.removeItem("advancedSearch");
			}
			if (backup?.search != null) {
				localStorage.setItem("sprawySearch", backup.search);
			} else {
				localStorage.removeItem("sprawySearch");
			}
			if (backup?.currentPage != null) {
				localStorage.setItem("currentPage", backup.currentPage);
			} else {
				localStorage.removeItem("currentPage");
			}
			if (backup?.selectedStatusFilter != null) {
				localStorage.setItem(
					"sprawySelectedStatusFilter",
					backup.selectedStatusFilter,
				);
			} else {
				localStorage.removeItem("sprawySelectedStatusFilter");
			}
			if (backup?.showAllActivity != null) {
				setShowAllActivity(backup.showAllActivity === "1");
			}
			localStorage.removeItem(SIMILAR_ACTIVE_KEY);
			localStorage.removeItem(SIMILAR_BACKUP_KEY);
			setTableKey((prev) => prev + 1);
		} catch {}
	}, [similar]);

	React.useEffect(() => {
		try {
			localStorage.setItem(storageKey, showAllActivity ? "1" : "0");
		} catch {
			// ignore storage errors
		}
	}, [showAllActivity]);

	return (
		<>
			<Breadcrumb
				style={{
					padding: "20px",
				}}
			>
				<Breadcrumb.Item>Strona główna</Breadcrumb.Item>
				<Breadcrumb.Item>Sprawy</Breadcrumb.Item>
			</Breadcrumb>
			<FastEnters></FastEnters>
			{/* <div className={["fullHeight, twoColumnsLayout"]} align="start" style={{gap: "0px", width: '100%', background: "white", height: "100%", display: "grid", gridTemplateColumns: "300px calc(100% - 300px)"}}> */}
			<div
				className={["fullHeight, twoColumnsLayout"]}
				align="start"
				style={{
					gap: "0px",
					width: "100%",
					maxWidth: "100%",
					minWidth: 0,
					boxSizing: "border-box",
					overflowX: "hidden",
					background: "white",
					height: "100%",
					display: "grid",
					gridTemplateColumns: "100%",
				}}
			>
				{/* <SideFilter setDeparts={setDeparts} setShowFilters={setShowFilters} showFilters={showFilters}/> */}
				<DataTable
					key={`${tableKey}-${resolvedStoragePrefix}`}
					departs={departs}
					setShowFilters={setShowFilters}
					showFilters={showFilters}
					activityMode={resolvedActivityMode}
					storageKeyPrefix={resolvedStoragePrefix}
					showActivityRangeToggle={!similar}
					activityRangeValue={showAllActivity ? "all" : "active"}
					onActivityRangeChange={(value) =>
						setShowAllActivity(value === "all")
					}
				/>
			</div>
		</>
	);
};
export default Sprawy;
